import { ApiError, ParamsNotFoundError } from '../../helpers/definedErrors';
import { api } from '../../config';

export const provisionExam = async (params = null) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
  }

  try {
    const url = `/v1/installs/${params.installSid}/exams/${params.examSid}/sessions/${params.sessionSid}/provisionExam`;
    const headers = {
      token: params.token,
    };
    const response = await api.patch(url, headers, {});
    return response.data;
  } catch (error) {
    console.error('Error provisioning exam!', { error });
    throw new ApiError();
  }
};
